import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: '[container]',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div [class]="classes" [ngClass]="{'container': !isFluid, 'container-fluid g-0': isFluid, 'g-0': isFluid || noGutters}">
      <div class="row" [ngClass]="{'g-0': isFluid || noGutters}">
        <div class="col">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  `
})
export class ContainerComponent {
  @Input() isFluid!: boolean;
  @Input() noGutters!: boolean;
  @Input() classes!: string;

  constructor() {}
}
